__turbopack_context__.v({
  "button": "BlockButton-module__PN5H-W__button",
  "buttonOutline": "BlockButton-module__PN5H-W__buttonOutline",
});
